var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSettingsSection',{attrs:{"title":_vm.t('activity', 'Notification')}},[_c('NcCheckboxRadioSwitch',{attrs:{"type":"checkbox","checked":_vm.emailEnabled},on:{"update:checked":function($event){return _vm.toggleEmailEnabled({emailEnabled: $event})}}},[_vm._v("\n\t\t"+_vm._s(_vm.t('activity', 'Enable notification emails'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }